import { inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { InteractionTrackingService } from './interaction-tracking.service';
import { IrisXHeadersEnum } from '@iris/common/models/IrisXHeadersEnum';

@Injectable()
export class ElasticTransactionInterceptor implements HttpInterceptor {
  private readonly interactionTrackingService: InteractionTrackingService = inject(InteractionTrackingService);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  intercept(srcReq: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let req = srcReq;
    const transaction = this.interactionTrackingService.getCurrentTransaction();
    const parentSpan = this.interactionTrackingService.getCurrentSpan();
    const span = transaction?.startSpan(`${srcReq.method} ${srcReq.url}`, 'user-interaction', { parentId: (parentSpan as unknown)?.['id'] });

    // Skip JSONP requests to avoid Error: JSONP requests do not support headers.
    if(srcReq.method !== 'JSONP' && span) {
      const traceId = (transaction as unknown)?.['traceId'];
      const spanId = (span as unknown)?.['id'];

      if(traceId && spanId) {
        const traceparent = `00-${traceId}-${spanId}-01`;

        req = srcReq.clone({ setHeaders: { 'Traceparent': traceparent } });
      }
    }

    return next.handle(req).pipe(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse && span) {
          const httpStatus = event.status;

          let contentLength: number | string = event.headers.get('Content-Length');
          const requestId = event.headers.get(IrisXHeadersEnum.REQ_ID);
          const responseTime = event.headers.get(IrisXHeadersEnum.RESPONSE_TIME);

          if(contentLength === undefined) {
            try {
              const json = JSON.stringify(event.body);
              contentLength = new TextEncoder().encode(json).length;
            } catch(e) {
              // Ignore error
            }
          }

          span.addLabels({
            httpStatus,
            contentLength,
            requestId,
            responseTime,
          });
        }
      }),
      finalize(() => {
        span?.end();
      }),
    );
  }
}
